<template>
  <div>
    <div class="card">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Controls -->
          <div class="controls d-flex">
            <div class="input-group">
              <input
                type="text"
                id="search-sources"
                aria-label="SearchSources"
                aria-describedby="SearchSources"
                placeholder="Search titles"
                class="form-control mr-2"
                v-model="searchWord"
                @input="applySearch"
              />
            </div>
            <button type="button" class="ml-auto btn btn-success" @click="openCreate">
              Add Title
            </button>
          </div>
          <!-- Page Controls End -->
          <div class="table-container">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Title</th>
                  <th style="width:23%" scope="col">Page name</th>
                  <th scope="col">Category</th>
                  <th scope="col">Competencies</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                <!--  <tr v-for="source in filteredSourceList" :key="source.id"> -->
                <tr v-for="item in filteredTitles" :key="item.id">
                  <th scope="row">
                    <div class="d-flex align-items-center">{{ item.title }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ item.page_name }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center">{{ item.category }}</div>
                  </th>
                  <th>
                    <div class="d-flex align-items-center flex-wrap">
                      <div v-for="competence in item.competences" :key="competence.id">
                        <i
                          v-if="competence.devicon !== null"
                          :class="`${competence.devicon} colored`"
                        ></i>
                        <img v-else src="/img/comstream.svg" alt="Jobshark logo" />
                      </div>
                    </div>
                  </th>
                  <th>
                    <button @click="setForEdit(item)" class="btn btn-link">
                      <i
                        style="font-size: 16px;
          color: #666; cursor:pointer"
                        class="fas fa-pencil-alt"
                      ></i>
                    </button>
                    <button @click="deleteWebsite(item)" class="btn btn-link">
                      <svgHelper name="delete"></svgHelper>
                    </button>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <Spinner :isLoading="isLoading" />

    <div
      class="modal fade add-user-modal"
      id="deleteCampaignModal"
      tabindex="-1"
      aria-labelledby="deleteCampaignModal"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteCampaignModalTitle">Delete Job Title</h5>
            <button
              @click="resetDelete"
              type="button"
              class="close"
              data-bs-dismiss="modal"
              aria-label="Close"
              ref="closeDelete"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <p class="text-center">
                  Please confirm that you want to delete <strong>{{ deleteTitle }}.</strong>
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="confirmDelete" type="button" class="btn btn-primary">
              Delete
            </button>

            <button
              @click="resetDelete"
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import titleMixin from '../../../mixins/titleMixin';

export default {
  mixins: [titleMixin],
  title() {
    return 'Website Integration | Jobshark';
  },
  /*   description() {
      return 'Page description goes here.';
    }, */
  canonicalLink() {
    return 'https://jobshark.eu/admin/campaigns';
  },
  components: {},
  data: () => ({
    isLoading: false,
    searchWord: '',
    deleteId: '',
    deleteTitle: '',
    titles: [],
    filteredTitles: [],
  }),
  methods: {
    openCreate() {
      this.$emit('create');
    },
    setForEdit(item) {
      this.$emit('edit', item);
    },
    getTitles() {
      axios(`${process.env.VUE_APP_API_URL}/admin/website/list`, {
        method: 'post',
        data: {
          page: 1,
          count: 10000,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      }).then(res => {
        this.titles = res.data.data;
        this.filteredTitles = res.data.data;
      });
    },
    deleteWebsite(item) {
      this.deleteTitle = item.title;
      this.deleteId = item.id;
      this.$nextTick(() => {
        // Ensure the data is set before showing the modal
        let deleteModal = new bootstrap.Modal(document.getElementById('deleteCampaignModal'));
        deleteModal.show();
      });
    },
    resetDelete() {
      this.deleteId = '';
      this.deleteTitle = '';
    },
    confirmDelete() {
      axios(`${process.env.VUE_APP_API_URL}/admin/website/delete`, {
        method: 'delete',
        data: {
          id: this.deleteId,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.getTitles();
          this.$refs.closeDelete.click();
        })
        .catch(() => {});
    },
    applySearch() {
      if (this.searchWord.length > 0) {
        this.filteredTitles = this.titles.filter(item =>
          item.title.toLowerCase().includes(this.searchWord.trim().toLowerCase()),
        );
      } else {
        this.filteredTitles = this.titles;
      }
    },
  },
  computed: {
    ...mapGetters(['getUserProfile']),
  },
  mounted() {
    this.getTitles();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.controls {
  font-family: $font-family-sans-lato;
  padding: 1rem;
  .input-group {
    width: 35%;
    position: relative;
    i {
      color: #a7a7a7;
      position: absolute;
      pointer-events: none;
      top: 8px;
      right: 12px;
      font-size: 21px;
      z-index: 99;
    }
    .form-control {
      border-radius: 4px !important;
    }
  }
  .btn-outline-success {
    border-color: #ced4da;
  }
}
.modal-body {
  .form-control {
    padding: 6px 12px !important;
    height: 42px !important;
  }
  .btn-outline-success {
    height: 40px;
  }
  .custom-checkbox {
    margin: 20px 0 5px 0;
  }
}

.edit-modal {
  .modal-body {
    .text-center {
      margin-bottom: 20px;
      i {
        font-size: 51px;
        display: block;
        margin: 20px auto 30px auto;
      }
      .btn-success {
        font-size: 13px;
      }
    }
    .list-unstyled {
      li {
        margin-bottom: 6px;
        padding-bottom: 6px;
        border-bottom: 1px dashed #ddd;
        font-size: 14px;
        span {
          float: right;
        }
      }
    }
  }
}
.table-container {
  padding: 1rem;
  .table {
    a {
      text-decoration: none;
    }
    thead {
      color: #222;
      font-size: 13px;
      font-weight: 700;
      text-transform: uppercase;
      th {
        vertical-align: middle;
        i {
          font-size: 31px;
          margin-right: 12px;
        }
        .fas {
          font-size: 14px;
          color: #666;
          transition: all 0.3s ease-in-out;
          -moz-transition: all 0.3s ease-in-out;
          -webkit-transition: all 0.3s ease-in-out;
        }
        &:last-of-type {
          a {
            margin-left: 12px;
            color: #666;
            i {
              font-size: 16px;
            }
          }
        }
        .is-open {
          .fas {
            -ms-transform: rotate(90deg); /* IE 9 */
            transform: rotate(90deg); /* Standard syntax */
          }
        }
      }
    }
    tbody {
      tr {
        th {
          font-weight: 400;
          font-size: 14px;
          i {
            font-size: 28px;
            margin-right: 18px;
          }
        }
        td {
          font-size: 14px;
          vertical-align: middle;
          font-family: $font-family-sans-lato;
          &:last-of-type {
            text-align: right;
            padding-right: 23px;
            a {
              color: #666;
              margin-left: 28px;
              i {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}

.isDisabled {
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
}

.fa-exchange-alt {
  -ms-transform: rotate(90deg); /* IE 9 */
  transform: rotate(90deg); /* Standard syntax */
}
</style>
